"use client"
import React, { useState, useEffect } from "react";

import EventView from "@/components/events/EventView";
import { useSearchParams } from "next/navigation";
import PageContainer from "@/components/shared/PageContainer";
import { useTenant } from "@/lib/providers/TenantProvider";

const EventViewPage = props => {
  const { profile } = useTenant();
  const searchParams = useSearchParams();
  const profileName = props.match.params.name;
  const eventId = props.match.params.eventId;
  const memberResourceName = props.match.params.mid;

  var utmParams = null;
  const utmSource = searchParams.get("utm_source");
  const utmMedium = searchParams.get("utm_medium");
  const utmCampaign = searchParams.get("utm_campaign");
  if (utmSource) utmParams = `utm_source=${utmSource}`;
  if (utmMedium) utmParams = utmParams ? utmParams + `&utm_medium=${utmMedium}` : `utm_medium=${utmMedium}`;
  if (utmCampaign) utmParams = utmParams ? utmParams + `&utm_campaign=${utmCampaign}` : `utm_campaign=${utmCampaign}`;

  const communityName = searchParams.get("community");
  const state = searchParams.get("state");
  const checkin = searchParams.get("checkin") === "true";
  const successParam = searchParams.get("success");
  const success = successParam === "true" ? true : successParam === "false" ? false : undefined;
  const error = searchParams.get("error");
  const test = searchParams.get("test") === "true";
  const token = searchParams.get("token");

  const [hash, setHash] = useState("");

  useEffect(() => {
    const onHashChange = () => {
      setHash(window.location.hash.substring(1));
    };
    onHashChange();
    window.addEventListener("hashchange", onHashChange);
    return () => window.removeEventListener("hashchange", onHashChange);
  }, []);

  return (
    <PageContainer
      name={profileName}
      profile={profile}
      showHeader={false}
      stickyMap={true}
      branded={true}
    >
      <EventView
        name={profileName}
        communityName={communityName}
        id={eventId}
        memberResourceName={memberResourceName}
        utmParams={utmParams}
        programCheckin={
          checkin
            ? {
                success: success,
                memberResourceName: memberResourceName,
                error: error,
                test: test,
                state: state,
                token: token
              }
            : undefined
        }
        hash={hash}
      />
    </PageContainer>
  );
};
export default EventViewPage;
